import { render, staticRenderFns } from "./DeleteLink.vue?vue&type=template&id=1aa37416"
import script from "./DeleteLink.vue?vue&type=script&lang=js"
export * from "./DeleteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports